import styled from "styled-components";

export const SectionTitle = styled.h3`
  color: ${({ theme }) => theme.colors.coal};
  font-size: 28px;
  font-weight: 500;
  margin-bottom: ${({ alone }) => (alone ? 0 : "32px")};
  line-height: 1.5;

  @media screen and (max-width: 425px) {
    font-size: ${({ responsive }) => (responsive ? "18px" : "28px")};
  }
`;

export const SectionText = styled.div`
  color: ${({ theme }) => theme.colors.asphalt};
  font-size: 16px;
  font-weight: 500;
  margin-bottom: ${({ alone }) => (alone ? 0 : "32px")};
  line-height: 1.5;
`;

export const LeadText = styled.h3`
  font-size: 38px;
  font-weight: 300;
  color: ${({ theme }) => theme.colors.coal};
  margin-bottom: 24px;

  @media screen and (max-width: 425px) {
    font-size: 28px;
  }
`;

export const LeadTextAccent = styled.span`
  font-size: 38px;
  font-weight: 900;
  color: ${({ theme }) => theme.colors.orange};

  @media screen and (max-width: 425px) {
    font-size: 28px;
  }
`;
